export default "https://cdn.questicon.mathletics.com/assets/images/AYR_Background-793f8c815d39087fc53cdff7777fd5b8.svg";